import React from 'react';
import { DEFAULT_GUID_TIPS } from '@/presentation/pages/diagnose/colouration/config';
import { UpdateField } from '@/presentation/pages/diagnose/log/UpdateField';
export const enum FiledType {
  QIMEI = 'qimei',
  ACCOUNT_ID = 'account_id',
  DEFAULT = 'default',
}


export const FILED_OPTIONS = [
  { label: '设备 ID', value: FiledType.QIMEI },
  { label: '用户 ID', value: FiledType.ACCOUNT_ID },
];

export const getGUID = (
  isAdmin: boolean,
  type?: string | null,
): {nameId: string, name: string, tip: React.ReactNode | string} => {
  const FILED_NAME: Record<string, {nameId: string, name: string, tip: React.ReactNode | string}> = {
    [FiledType.QIMEI]: {
      nameId: '设备ID',
      name: '设备',
      tip: <span>当前日志显示的全局标识符（GUID）为“设备ID”。若贵方产品在接入日志SDK时，
      实际使用的是“用户ID”作为GUID
        {isAdmin ? '请**' : ''}
        {isAdmin ? <UpdateField/> : ''}
        {isAdmin ? '**，' : ''}
        以便团队其他成员理解。
      请参考「<a href={'https://docs.bugly.woa.com/diagnose/guide'} target={'_blank'}>日志SDK</a>」接入指引，查看GUID的设置。</span>,
    },
    [FiledType.ACCOUNT_ID]: {
      nameId: '用户ID',
      name: '用户',
      tip: <span>当前日志显示的全局标识符（GUID）为“用户ID”。若贵方产品在接入日志SDK时，
      实际使用的是“设备ID”作为GUID，
        {isAdmin ? '请**' : ''}
        {isAdmin ? <UpdateField/> : ''}
        {isAdmin ? '**，' : ''}以便团队其他成员理解。请参考「<a href={'https://docs.bugly.woa.com/diagnose/guide'} target={'_blank'}>日志SDK</a>」接入指引，查看GUID的设置。</span>,
    },
    [FiledType.DEFAULT]: { // 默认值，避免显示空白
      nameId: '设备ID',
      name: '设备',
      tip: DEFAULT_GUID_TIPS,
    },
  };

  if (!type || !FILED_NAME?.[type]) {
    return FILED_NAME[FiledType.DEFAULT];
  }
  return FILED_NAME?.[type];
};

